(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-tabs-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return (value || '').trim().toLowerCase();
    }

    function setItemOpen(section, item, open) {
      var btn = item.querySelector('[data-faq-toggle]');
      var panel = item.querySelector('[data-faq-panel]');
      if (!btn || !panel) return;

      if (open && section.dataset.singleOpen === 'true') {
        var openItems = section.querySelectorAll('[data-faq-item].faq-item--open');
        for (var i = 0; i < openItems.length; i++) {
          if (openItems[i] !== item) {
            setItemOpen(section, openItems[i], false);
          }
        }
      }

      item.classList.toggle('faq-item--open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function toggleItem(section, item) {
      var isOpen = item.classList.contains('faq-item--open');
      setItemOpen(section, item, !isOpen);
    }

    function collapseAll(section) {
      var openItems = section.querySelectorAll('[data-faq-item].faq-item--open');
      for (var i = 0; i < openItems.length; i++) {
        setItemOpen(section, openItems[i], false);
      }
    }

    function applyFilter(section, tabEl) {
      if (!tabEl) return;
      var showAll = tabEl.hasAttribute('data-faq-all');
      var targetCategory = normalize(tabEl.getAttribute('data-category'));

      var tabs = section.querySelectorAll('[data-faq-tab]');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].setAttribute('aria-selected', tabs[i] === tabEl ? 'true' : 'false');
      }

      var items = section.querySelectorAll('[data-faq-item]');
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        var itemCategory = normalize(item.getAttribute('data-category'));
        var show = showAll || itemCategory === targetCategory;
        item.classList.toggle('faq-item--hidden', !show);
      }

      collapseAll(section);
    }

    function handleTabsKeydown(section, event) {
      var key = event.key;
      if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-faq-tab]'));
      if (!tabs.length) return;
      var currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var nextIndex = currentIndex;
      if (key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      else if (key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      else if (key === 'Home') nextIndex = 0;
      else if (key === 'End') nextIndex = tabs.length - 1;

      event.preventDefault();
      tabs[nextIndex].focus();
      applyFilter(section, tabs[nextIndex]);
    }

    function initFaqSection(section) {
      if (!section || section.dataset.faqInitialized === 'true') return;
      section.dataset.faqInitialized = 'true';

      var tabs = section.querySelectorAll('[data-faq-tab]');
      var toggles = section.querySelectorAll('[data-faq-toggle]');
      var tablist = section.querySelector('[data-faq-tablist]');

      for (var i = 0; i < tabs.length; i++) {
        (function (tab) {
          tab.addEventListener('click', function () {
            applyFilter(section, tab);
          });
        })(tabs[i]);
      }

      if (tablist) {
        tablist.addEventListener('keydown', function (event) {
          handleTabsKeydown(section, event);
        });
      }

      for (var k = 0; k < toggles.length; k++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var item = btn.closest('[data-faq-item]');
            if (item) toggleItem(section, item);
          });
        })(toggles[k]);
      }

      if (tabs.length) {
        applyFilter(section, tabs[0]);
      } else {
        var allItems = section.querySelectorAll('[data-faq-item]');
        for (var m = 0; m < allItems.length; m++) {
          allItems[m].classList.remove('faq-item--hidden');
        }
      }
    }

    function initAll(root) {
      if (!root) return;
      if (root.nodeType === 1 && root.matches && root.matches('.faq-section')) {
        initFaqSection(root);
      }
      var sections = root.querySelectorAll ? root.querySelectorAll('.faq-section') : [];
      for (var i = 0; i < sections.length; i++) {
        initFaqSection(sections[i]);
      }
    }

    function run() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target || document);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) return;

      var item = document.querySelector('[data-faq-item][data-block-id="' + blockId + '"]');
      if (item) {
        var section = item.closest('.faq-section');
        if (!section) return;
        var itemCategory = normalize(item.getAttribute('data-category'));
        var tabs = section.querySelectorAll('[data-faq-tab]');
        var matchTab = null;
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].hasAttribute('data-faq-all')) {
            if (!matchTab) matchTab = tabs[i];
          } else if (normalize(tabs[i].getAttribute('data-category')) === itemCategory) {
            matchTab = tabs[i];
          }
        }
        if (matchTab) applyFilter(section, matchTab);
        setItemOpen(section, item, true);
        if (item.scrollIntoView) item.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      var tab = document.querySelector('[data-faq-tab][data-block-id="' + blockId + '"]');
      if (tab) {
        var tabSection = tab.closest('.faq-section');
        if (tabSection) applyFilter(tabSection, tab);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
